interface AvatarProps {
  name?: string;
  className?: string;
}

export function Avatar({ name, className = '' }: AvatarProps) {
  const initials = name
    ? name
        .trim()
        .split(/\s+/)
        .map((part) => part[0])
        .slice(0, 2)
        .join('')
        .toUpperCase()
    : '?';

  return (
    <div
      className={`w-9 h-9 shrink-0 rounded-full bg-surface-700 border border-surface-500 flex items-center justify-center text-xs font-semibold text-neutral-200 ${className}`}
      aria-hidden="true"
    >
      {initials}
    </div>
  );
}
